export default __webpack_public_path__ + "static/media/newyear7.6f605cee.png";